export function isWidget(): boolean {
  return window !== window.parent;
}

export default {
  isWidget
};
